import React, { useState, useMemo, useEffect } from 'react';
import PDFViewer from '../Shared/PDFViewer';
import { useAuth } from "../../src/Context/AuthContext"

const Agent1099Section = ({ model, rowsPerPage = 10 }) => {
    //State Variables
    const docs = model.tax1099Forms || [];
    const filtered = docs.filter(doc => doc);
    const [currentPage, setCurrentPage] = useState(1);
    const totalEntries = filtered.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [pdfBlob, setPdfBlob] = useState(null);
    const { logout } = useAuth();

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    const paginatedDocs = useMemo(() => {
        const start = (currentPage - 1) * rowsPerPage;
        return filtered.slice(start, start + rowsPerPage);
    }, [filtered, currentPage, rowsPerPage]);

    useEffect(() => {
        if (filtered.length > 0 && !selectedDoc) {
            const first = filtered[0];
            setSelectedDoc(first);

            (async () => {
                const blob = await getPDF(first.id);
                if (blob) setPdfBlob(blob);
            })();
        }
    }, []); // run only once

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    const getPDF = async (id) => {
        try {
            const res = await fetch(`${apiURL}/image/pdf/view?documentID=${id}`, {
                method: "GET",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (!res.ok) {
                throw new Error("Failed to fetch PDF");
            }

            return await res.blob();
        } catch (err) {
            console.error(err);
            alert("Could not retrieve file");
            return null;
        }
    };

    const handleSelectDoc = async (doc) => {
        setSelectedDoc(doc);
        const blob = await getPDF(doc.id);
        if (blob) setPdfBlob(blob);
    };

    const from = totalEntries === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const to = Math.min(currentPage * rowsPerPage, totalEntries);

    return (
        <div className="container container-section" id="documents-container">
            {filtered.length === 0 ? (
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <h5>No 1099 Documents Found</h5>
                    </div>
                </div>
            ) : (
                <div className="split-view">
                    {/* LEFT SIDE: Document List */}
                    <div className="doc-list">

                        {/* Mobile-only view button */}
                        <div className="mobile-view-button" onClick={() => selectedDoc && window.open(URL.createObjectURL(pdfBlob), '_blank')}>
                            View PDF
                        </div>
                        <table className="policy-results-table">
                            <thead>
                                <tr>
                                    <th>Document Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedDocs.map((doc, index) => (
                                    <tr
                                        key={index}
                                        onClick={() => handleSelectDoc(doc)}
                                        className={selectedDoc?.id === doc.id ? 'selected' : ''}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td>{doc.displayName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="pagination-bar">
                            <div className="pagination-summary">
                                Showing {from}-{to} of {totalEntries} entries
                            </div>
                            <div className="pagination-controls">
                                <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>&#171;</button>
                                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>&#8592;</button>

                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(page =>
                                        page === 1 ||
                                        page === totalPages ||
                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                    )
                                    .map(page => (
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            className={currentPage === page ? 'active' : ''}
                                        >
                                            {page}
                                        </button>
                                    ))}

                                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>&#8594;</button>
                                <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>&#187;</button>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE: PDF Viewer */}
                    <div className="pdf-viewer">
                        {pdfBlob ? (
                            //<iframe
                            //    src={URL.createObjectURL(pdfBlob)}
                            //    title="PDF Viewer"
                            //    className="pdf-iframe"
                            //    />
                            <PDFViewer src={URL.createObjectURL(pdfBlob)} fileId={selectedDoc.id} fileName={selectedDoc?.displayName} serviceForm={false} />
                        ) : (
                            <div className="no-selection">
                                <p>Select a 1099 document to view</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Agent1099Section;
